<script setup lang="ts">
    import { defineAsyncComponent } from 'vue';
    import TopBannerRight from '../components/oferta/TopBannerRight.vue'
    import FormarBloque from '../components/oferta/FormarBloqueNeo.vue'; 
    const MtrPlanEstudios = defineAsyncComponent(() => import('../components/oferta/MtrPlanEstudios.vue')) ; 
    const VerModelo = defineAsyncComponent(() => import('../components/oferta/VerModelo.vue'));
const PoliticaIA = defineAsyncComponent(() => import('../components/oferta/PoliticaIA.vue'))
    const CalendarioOferta = defineAsyncComponent(() => import('../components/oferta/CalendarioOferta.vue'))
    // const DescargaFolleto = defineAsyncComponent(() => import('../components/oferta/DescargaFolleto.vue')) ; 
    // const MtrModEjec = defineAsyncComponent(() => import('../components/oferta/MtrModEjec.vue')) ; 
    // const EgresadosHuma = defineAsyncComponent(() => import('../components/oferta/EgresadosHuma.vue')) ;
</script>

<template>
    <TopBannerRight
        :img="'background-image: url(../../pagesImages/banner-psico1.jpg);'"
        :nivel="'Maestr&iacute;a en'"
        :carrera="'Psicoterapia'"
        :complemento="'con un Enfoque Psicoanalítico'"
        :frase="'Las emociones inexpresadas nunca mueren. Son enterradas vivas y salen m&aacute;s tarde de peores formas'"
        :autor="'Sigmund Freud'"
    />

    <FormarBloque
        :img="'../../pagesImages/student8.jpg'"
        alt="Alumna de Maestría en Psicoterapia con un Enfoque Psicoanalítico"
        :link="'/requisitos-maestria'"
        :frase="'Formación especializada para psicoterapeutas que integran investigación, diagnóstico preciso y tratamiento personalizado'"
        :testo1="'La Maestría en Psicoterapia con un Enfoque Psicoanalítico desarrolla conocimientos especializados en el análisis del inconsciente, con habilidades para el diagnóstico, pronóstico e intervención terapéutica desde el enfoque psicoanalítico, además de potenciar las competencias para ofrecer una consulta de psicoterapia responsable y de calidad.'"
        :testo3="'Está orientada a la formación de psicoterapeutas, profesionales interesados en desarrollar sus competencias y habilidades en el trabajo científico de investigación en el campo de la Psicoterapia con el método clínico.'"
    />

    <div class="flex items-center justify-center my-10">
    </div>

    <MtrPlanEstudios
        :ejecutivo="true"
        :virtual="true"
    />

    <VerModelo esco=""
    ejec="/pagesImages/Programas/Maestria/Plan_De_Estudios_Psicoterpia_Web.webp,/pagesImages/Programas/Maestria/Plan_De_Estudios_Psicoterpia_Cel.webp"
    virt="/pagesImages/Programas/Maestria/Plan_De_Estudios_Psicoterpia_Web.webp,/pagesImages/Programas/Maestria/Plan_De_Estudios_Psicoterpia_Cel.webp"
    :escoT="false"
    :ejecT="true"
    :virtT="true" />

    
    <!-- <VerModelo esco=""
    ejec="/pagesImages/Programas/Maestria-ant/maestria-psicoterapia-ejecutivo.webp"
    virt="/pagesImages/Programas/Maestria-ant/maestria-psicoterapia-ejecutivo.webp"
    :escoT="false"
    :ejecT="true"
    :virtT="true" /> -->

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-4 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block font-serif text-[42px] text-hgold text-left" style="">Estructura académica</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-xl text-left mb-3">(Bloques trimestrales):</span>
                        </h2>
                        <ul class="list-disc pl-5 mb-4">
                            <li><b>Bloque introductorio:</b> Fundamentos teóricos y conceptuales del Psicoanálisis; bases conceptuales del Psicoanálisis y teoría Psicoanalítica del desarrollo.</li>
                            <li><b>Bloque teórico:</b> Comprensión dinámica de los procesos psíquicos y la relación con otras corrientes, psicodinámica, bases psicoanalíticas de la neurosis y otras psicoterapias breves, focales y humanísticas.</li>
                            <li><b>Bloque técnico:</b> Herramientas técnicas y primeros acercamientos clínicos desde el psicoanálisis, teoría psicoanalítica, transferencia e interpretación, y etiología de la psicosis desde el Psicoanálisis.</li>
                            <li><b>Bloque psicopatología:</b> Análisis clínico desde la perspectiva psicoanalítica de las estructuras neuróticas y psicóticas, psicopatología psicoanalítica y etiología de la neurosis desde el Psicoanálisis.</li>
                            <li><b>Bloque psicoanálisis actual:</b> Evolución del pensamiento psicoanalítico y abordaje clínico contemporáneo, post-freudianos: escuela inglesa, el paciente fronterizo e intervenciones en psicoterapia para problemáticas específicas.</li>
                            <li><b>Seminario de titulación:</b> Desarrollo de un proyecto aplicado para la obtención del grado.</li>
                            <!-- <li><b>Seminario de Inteligencia Artificial.</b> Conocimiento, comprensión y aplicación de las herramientas de Inteligencia Artificial en entornos académicos, profesionales y laborales, fortaleciendo las habilidades y capacidades.</li> -->
                        </ul>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/estructura-academica-educacion.webp" alt="Alt pendiente" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section>
    <CalendarioOferta nombre="Maestría en Psicoterapia con un Enfoque Psicoanalítico" 
  :inicios="[true, false, true, false, true, false, true, false]"></CalendarioOferta>

    <!-- <MtrModEjec class="mb-16" />

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">Metodología</span>
                        </h2>
                        <p class="mb-4">
                            El modelo ejecutivo se desarrolla bajo la siguiente estructura:
                        </p>
                        <ul class="list-disc pl-5 mb-4">
                            <li>Consta de 6 bloques trimestrales.</li>
                            <li>Cada bloque equivale a tres materias fusionadas, impartidas por un especialista en la materia.</li>
                            <li>Se imparten clases un día a la semana, tres horas de clases presenciales.</li>
                            <li>El modelo educativo tiene una duración de diez semanas de clases, y una semana adicional culminando con una evaluación final.</li>
                            <li>La evaluación se compone de participación en clase, foros, trabajos y examen final, integrando así un proceso de aprendizaje integral.</li>
                        </ul>
                        <p>
                            Este modelo permite a los estudiantes desarrollar habilidades especializadas con un enfoque práctico y estratégico, alineado con las exigencias del mundo profesional actual.
                        </p>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/universidad-fisica-virtual.webp" alt="Estudiantes de maestría en alta dirección corporativa universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section> -->
    
    <section class="lg:flex items-center justify-center bg-cover bg-[center] bg-no-repeat mb-16" style="background-image: url(/pagesImages/madin3.jpg); position: relative; background-attachment: fixed; background-position: left; background-repeat: no-repeat; background-size: cover; overflow: hidden; transition: transform 0.3s ease;">
        <div class="lg:flex items-center justify-center w-full h-full my-16">
            <div class="lg:flex items-center justify-between w-full max-w-[1200px]">
                <img src="/pagesImages/perfil-egresado-maestrias.webp" alt="Egresados de maestría en Psicoterapia con un Enfoque Psicoanalítico." class="lg:p-0 w-full lg:max-w-[520px] md:px-16 px-6 pt-6"/>
                <div class="flex flex-col lg:justify-start justify-center items-center lg:items-start lg:w-[50%] w-full lg:my-24 py-12 text-justify lg:px-0  px-8">
                    <h2>
                        <span class="block text-[28px] text-hwine leading-none text-center md:text-left">Perfil del egresado de la maestría en</span>
                        <span class="sr-only whitespace-nowrap">&nbsp;</span>
                        <span class="block text-hwine text-[42px] mb-4 leading-tight text-center md:text-left font-serif "> Psicoterapia con un Enfoque Psicoanalítico</span>
                    </h2>
                    <p class="text-justify text-gray-800 lg:hyphens-manual hyphens-auto">A través de la adquisición de una perspectiva teórica, los egresados integran el conocimiento en la práctica clínica supervisada. Este proceso forma profesionales con un robusto sustento teórico y metodológico psicoanalítico, capacitándolos para ejercer como psicoterapeutas.</p>
                    <br>
                    <router-link to="/contacto">
                        <div class="flex items-center justify-center w-[140px] h-[35px] hover:bg-hwine bg-hgold text-white  text-lg transition duration-300 ease-in-out">
                            <span>Inscr&iacute;bete</span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </section>

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-4 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between w-full">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block leading-none text-left text-[28px]" style="">Cinco razones para elegir</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">Universidad Humanitas:</span>
                        </h2>
                        <ul class="list-disc pl-5 mb-4">
                            <li>Modelo educativo especializado.</li>
                            <li>Excelencia académica.</li>
                            <li>Instalaciones de primer nivel.</li>
                            <li>Costos accesibles.</li>
                            <li>Acreditaciones reconocidas (SEP, ESR y GPTW).</li>
                        </ul>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/beneficios-estudiar-universidad-humanitas.webp" alt="Beneficios de estudiar en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section>
    <PoliticaIA />
</template>

<style scoped>
</style>